import { render, staticRenderFns } from "./EntityDuplicate.vue?vue&type=template&id=795a8188&lang=pug"
import script from "./EntityDuplicate.vue?vue&type=script&lang=js"
export * from "./EntityDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports